import { Environment } from "@environments/environment.interface";

export const environment: Environment = {
	build: {
		adminRoute: "admin",
		companyCommonName: "BPL Engineering",
		companyLongName: "BPL Engineering Group Ltd.",
		companyShortName: "BPL",
		flowId: 43,
		lowestEdiOrderPriority: 25,
		lowestWorkOrderStagePriority: 25,
		production: false,
		thicknesses: [0, 0.2, 0.4, 0.5, 0.6, 0.64, 0.7, 0.8, 0.9, 1, 1.2, 1.4, 1.5, 1.6, 1.8, 2, 2.3, 2.5, 2.6, 2.8, 3, 3.5, 4, 4.5, 5, 6, 7, 8, 10, 12, 15, 20, 25],
		version: "2.1.0"
	},
	server: {
		accessTokenExpiryMilliseconds: 3600000,
		accessTokenRefreshMilliseconds: 3540000,
		apiURL: "https://api-staging.bplflow.com",
		authKey: "5dbsvGCsXrynN62Kd7T5BrEJWoYOmWIY",
		storageSAS: "sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2024-01-20T17:51:33Z&st=2022-01-20T09:51:33Z&sip=0.0.0.0-255.255.255.255&spr=https&sig=FrweKH24N%2FHJ5dAVFi7CsSeWqOL0an2l8TrbIVlKcWg%3D",
		storageUrl: "https://flowfe.blob.core.windows.net",
		stripeKey: ""
	}
};